import { IRegistrationEvent } from '../../models/registrationevent.model';
import { RegistrationEventAction, RegistrationEventActionType } from '../actions/registrationevent.action';

export const RegistrationEventReducer = (
    state: IRegistrationEvent[] = new Array<IRegistrationEvent>(),
    action: RegistrationEventAction
) => {
    switch (action.type) {
        case RegistrationEventActionType.FETCH_REGISTRATIONEVENTS:
            return action.registrationEvents;
        case RegistrationEventActionType.ADD_REGISTRATIONEVENT:
            return [
                ...state,
                action.registrationEvent
            ];
        case RegistrationEventActionType.SET_REGISTRATIONEVENT_TO_COMPLETE:
            return state.map((registrationEvent: IRegistrationEvent) => {
                if (registrationEvent.id === action.id) {
                    registrationEvent = { ...registrationEvent, complete: true };
                }
                return registrationEvent;
            });
        case RegistrationEventActionType.DELETE_REGISTRATIONEVENT:
            return state.filter((registrationEvent: IRegistrationEvent) =>
                registrationEvent.id !== action.id
            );
        default:
            return state;
    }
}